<script>
    import NewsletterSubscriber from '../newsletter/NewsletterSubscriber';
    import LoadingButton from '../common/LoadingButton';
    import CollapsibleList from '../common/CollapsibleList';
    import DiscountFrame from './DiscountFrame';
    import RenderNotifier from '../common/RenderNotifier';
    import { featuredDiscountService } from '../../../common/service/resource';
    import Alert from '../common/Alert';
    import DiscountHero from './DiscountHero';
    import Modal from '../common/container/Modal';
    import TextField from '@bit/chicorei.chicomponents.input.text-field';

    export default {
        el: '#discounts-content',

        name: 'DiscountsPage',

        components: {
            alert: Alert,
            modal: Modal,
            'render-notifier': RenderNotifier,
            'discount-hero': DiscountHero,
            'discount-frame': DiscountFrame,
            'input-field': TextField,
            'loading-button': LoadingButton,
            'newsletter-subscriber': NewsletterSubscriber,
            'collapsible-list': CollapsibleList,
        },

        data() {
            return {
                requests: 0,

                mainDiscount: null,
                discounts: null,

                discountToReveal: null,

                alert: null,
                email: null,
                submitting: false,

                faqLeft: [
                    {
                        head: 'O que são esses cupons?',
                        text: [
                            'São cupons promocionais e exclusivos desta página que garantem condições especiais para suas compras na Chico Rei. São gerados assim que você cadastra seu email.',
                            'Alguns deles oferecem descontos para qualquer produto do nosso site. Outros, para itens específicos ou kits. Por isso, fique atento à categoria do seu cupom e leia com atenção o(s) benefício(s) que ele te proporciona!',
                        ],
                    },
                    {
                        head: 'Como usar um cupom de desconto da Chico Rei?',
                        html: `
                            <p>Para usar seu cupom, siga os passos:</p>
                            <ol>
                            <li>Nesta mesma página, aqui em cima, escolha o benefício que mais faça sentido para você;</li>
                            <li>Clique em “revelar desconto”;</li>
                            <li>Preencha seu email, confirme, e enviaremos o código do cupom;</li>
                            <li>Na sua caixa de entrada, abra o email e clique sobre o código do cupom para ativar o desconto;</li>
                            <li>Pronto! O cupom foi ativado e você já pode aproveitar no nosso site!</li>
                            </ol>
                            <p>Caso você ache mais fácil, também dá certo copiar o <strong>código do cupom no seu email</strong> e colar na hora de fechar o pedido, na sacola. Os cupons não são cumulativos com outros descontos e promoções da Chico Rei.</p>
                        `,
                    },
                    {
                        head: 'Como economizar na Chico Rei?',
                        text: [
                            'Para ir além dos cupons de desconto, é só nos acompanhar pelas redes sociais! Por lá, você sempre fica sabendo antes de novidades e promoções, além de ter conteúdo exclusivo. Outra boa ideia é se cadastrar para receber a newsletter da Chico Rei!',
                        ],
                    },
                    {
                        head: 'Newsletter Chico Rei',
                        text: [
                            'Logo acima, nesta mesma página, você encontra um campo para se cadastrar para receber a nossa newsletter. E você deveria fazer isso agora! Tenha acesso, por email, em primeira mão, a promoções exclusivas e condições especiais. Ah, e sempre nos lembramos de fazer ações especiais para nossos assinantes em datas comemorativas :)',
                        ],
                    },
                ],
                faqRight: [
                    {
                        head: 'Encontre os melhores preços do nosso site!',
                        text: [
                            'No canto esquerdo das páginas de produtos você encontra os nossos filtros. Um deles separa os produtos especificamente por valor! Caçando pechinchas? É só selecionar o filtro com o valor mais baixo e pronto: os produtos mais baratos daquela categoria vão aparecer! E você também pode ordenar os produtos por preço, se preferir.',
                        ],
                    },
                    {
                        head: 'Frete grátis',
                        text: [
                            'Na Chico Rei, o frete é grátis a partir de R$150* ' +
                                ' (Consulte condições na sacola de compras)',
                        ],
                    },
                    {
                        head: 'A Chico Rei é confiável?',
                        html: `
                            <p>Sim, pode confiar na gente! Mais de uma década de história no comércio eletrônico e mais de 300 mil clientes atestam nossa responsabilidade para garantir a sua segurança. Temos certificados diversos e, inclusive, uma página inteira dedicada a explicar e esclarecer qualquer dúvida que possa surgir na hora de comprar na Chico Rei: <a class="text-primary" href="https://chicorei.com/seguranca">https://chicorei.com/seguranca</a>.</p>
                        `,
                    },
                    {
                        head: 'Como trocar ou pedir reembolso na Chico Rei?',
                        html: `
                            <p>Por aqui fazemos tudo de forma simples e transparente. Caso adquira um produto Chico Rei e ele apresente algum defeito ou não satisfaça as expectativas, nós realizamos troca ou reembolso.</p>
                            <p>Contando a partir do recebimento, você tem 30 dias corridos para realizar a troca. O primeiro passo é fazer o login no site, entrar em “minha conta” e clicar na aba “trocas”. Lá você encontra as instruções detalhadas do processo. A primeira troca, independente do motivo, é gratuita!</p>
                            <p>Se a sua decisão foi devolver o(s) produto(s), você deve entrar em contato com a gente pelo email <a class="text-primary" href="mailto:contato@chicorei.com.br">contato@chicorei.com.br</a> ou pelo telefone <strong>(32)3211-9277</strong>. Ou, se o seu pedido ainda não foi enviado, basta realizar o cancelamento e a compra será automaticamente anulada.</p>
                            <p>Para troca ou devolução, o(s) produto(s) não pode(m) conter sinais de uso, de lavagem ou qualquer avaria.</p>
                        `,
                    },
                ],
            };
        },

        created() {
            this.fetchDiscounts();
        },

        methods: {
            fetchDiscounts() {
                this.requests++;
                featuredDiscountService
                    .query()
                    .then((response) => {
                        this.discounts = response.data.filter(
                            (d) => !d.days_until_hide && d.discount
                        );
                        this.mainDiscount = response.data.find(
                            (d) => d.days_until_hide && d.discount
                        );
                    })
                    .catch((e) => {
                        // todo
                    })
                    .then(() => this.requests--);
            },

            submit() {
                this.submitting = true;
                featuredDiscountService
                    .sendEmail(this.discountToReveal.id, {
                        email: this.email,
                    })
                    .then(() => {
                        this.alert = {
                            message: 'Cupom enviado com sucesso',
                        };
                    })
                    .catch(() => {
                        this.alert = {
                            message: 'Não foi possível enviar o cupom',
                            isError: true,
                        };
                    })
                    .then(() => (this.submitting = false));
            },
        },
    };
</script>
